<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 配送・お支払いについて
        v-layout.pa-3.mt-3.white_container.justify-center(row wrap)
          h2 配送について
          dl
            dt 送料
            dd
              | 日本国内への送料は、以下の通りとなります。
              v-layout(row wrap)
                v-flex.pa-2(xs12 md6 lg4 v-for="(deliveryFee, index) in deliveryFeeTable", :key="index")
                  ul.pl-2(style="list-style: none;")
                    li
                      h4.my-2 {{deliveryFee.regions.join('/')}}
                      p.my-2 ({{deliveryFee.prefs.join('/')}})
                      ul.pl-4(style="list-style: none;")
                        li(v-for="fee in deliveryFee.fees")
                          div.app-line
                            span.app-line-title {{fee.min|number}} 〜 {{fee.max|number}} 円
                            span.app-line-text {{fee.fee|number}}
                            span.app-line-suffix 円
            dt ご注文日・お届け日
            dd
              | 土日祝にいただいたご注文につきましては、翌営業日の確認となります。
              br
              | お届け日は土曜日、日曜日のみとなります。ご了承ください。
            dt 受注締め時間
            dd
              | 午前11時
              br
              | 午前11時以降のご注文は次回出荷日分のご対応となります。
            dt 配送希望時間帯
            span お届けの時間帯は以下の選択肢からお選びいただけます。
            ul
              li.ml-4(v-for="deliveryTime in deliveryTimeTable") {{deliveryTime}}
          h2 お支払いについて
          dl.mb-3
            dt お支払い方法
            dd
              | お支払いは、代金引換のみとなります。
              br
              | 商品価格に対応した代引手数料は、以下の通りとなります。
              v-layout(row wrap)
                v-flex(xs12 md12)
                  ul(style="list-style: none;")
                    li(v-for="codFee in codFeeTable")
                      div.app-line
                        span.app-line-title {{codFee.min|number}} 〜 {{codFee.max|number}} 円
                        span.app-line-text {{codFee.fee|number}}
                        span.app-line-suffix 円
          h2 ご注意
          dl
            dt 冷凍商品のお取り扱いについて
            dd 商品の受け取り後は、できるだけ早く冷凍庫などに保存してくださいますようお願いします。
            dt 返品・交換について
            dd
              h3 （1）商品の不備による返品・交換について
              p.indent
                | 商品がお手元に着いたら、ただちに破損がないか、商品の相違がないかご確認ください。
                br
                | 商品には万全を期しておりますが、万が一不良品等ございましたらお問い合わせフォームまたは下記電話番号へご連絡の上、弊社へ着払いにてお送りください。
                br
                | 不良品、破損品の場合、返品送料は弊社が負担いたします。
                br
                | なお、開封後の商品の場合、返品・交換に応じられない場合もございますので、予めご了承ください。
                br
              h3 （2）お客様ご都合による返品・交換について
              p.indent
                | 商品特質上、お客様のご都合によるキャンセル、お受取り辞退、返品は応じかねますので予めご了承ください。
            br
          p
            | ご不明な点がございましたら、
            router-link(to="/contact") お問い合せフォーム
            | よりお問い合せ下さい。
    CommonFooter
</template>

<script>
import { mapGetters } from 'vuex'
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('app/shop', ['deliveryFeeTable', 'deliveryTimeTable', 'codFeeTable'])
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc
h2
  background $color-primary
  color $color-secondary
.indent
  padding-left 2.2rem
h3
  margin-top 2rem
  font-size 1rem
dt
  text-align center
  font-weight 700
  margin 2rem 0 1rem
  border-bottom 1px solid $color-primary

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Guide/index.vue